import React, { useEffect, useState } from 'react';
import { getRequest } from '../../utils/APICall';
import LeaveForm from './LeaveForm';
import { PencilSquareIcon, } from '@heroicons/react/16/solid';

const LeavesTable = () => {
  const [leaveCounts, setLeaveCounts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [editingData, setEditingData] = useState(null);
  const T_Head = ["S.No", "Department", "Leave Type", "Leaves", "From Date", "To Date", "Action"];

  const fetchLeaveCounts = async () => {
    try {
      const response = await getRequest('getLeaveCount');
      // console.log(response)
      if (response.success) {
        setLeaveCounts(response.data);
        //console.log("Leaves Fetched:", response.data);
      } else {
        setLeaveCounts([])
        // console.error("Failed to fetch leave counts:", response.message);
      }

    } catch (error) {
      console.log(error)
      setLeaveCounts([])
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLeaveCounts();
  }, []);
  // console.log('EDIT DAta,', editingData)
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = date.getDate().toString().padStart(2, '0'); // 07
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase(); // JUN
    const year = date.getFullYear(); // 2025
    return `${day} ${month} ${year}`;
  };

  const getLeaveTypeLabel = (type) => type === 1 ? "Annual Leave" : type === 2 ? "Sick Leave" : `Type ${type}`;

  return (
    <div className="font-[sans-serif] overflow-x-auto ">
      <LeaveForm
        editingData={editingData}
        onSuccess={fetchLeaveCounts}
        resetEditing={() => setEditingData(null)}
      />

      {loading ? (
        <table className="min-w-full bg-white dark:bg-darkgray">
          <thead className="bg-primaryPurple dark:bg-lightgrey text-white text-sm">
            <tr>
              {T_Head.map((item, index) => (
                <th className="text-left p-3 font-semibold" key={index}>
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array(10).fill(0).map((_, rowIndex) => (
              <tr
                key={rowIndex}
                className="even:bg-blue-50 dark:even:bg-gray-800"
              >
                {T_Head.map((_, colIndex) => (
                  <td
                    key={colIndex}
                    className="p-4 border-b border-gray-100 dark:border-gray-700 animate-pulse"
                  >
                    <div className="h-4 bg-gray-300 dark:bg-gray-700 rounded w-full"></div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <table className="min-w-full bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-700 rounded-lg shadow-sm">
          <thead className="bg-primaryPurple dark:bg-lightgrey text-white text-sm">
            <tr>
              {T_Head.map((item, index) => (
                <th key={index} className="text-left p-3 font-semibold">
                  {item}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {leaveCounts.length === 0 ? (
              <tr className="bg-gray-50 dark:bg-gray-800">
                <td colSpan={7}>
                  <div
                    className="min-h-[200px] sm:min-h-[300px] lg:min-h-[400px]
              flex flex-col items-center justify-center
              text-center gap-2"
                  >
                    <p className="animate-pulse text-sm sm:text-base font-medium text-gray-800 dark:text-gray-100">
                      Employee Leaves data is currently unavailable
                    </p>
                    <p className="text-xs sm:text-sm text-gray-500 dark:text-gray-400">
                      Please check back later or try refreshing.
                    </p>
                  </div>
                </td>
              </tr>
            ) : (
              leaveCounts?.map((item, index) => (
                <tr
                  key={index}
                  className="even:bg-gray-100 dark:even:bg-gray-800 text-sm text-gray-800 dark:text-gray-100"
                >
                  <td className="p-3">{index + 1}</td>
                  <td className="p-3">{item?.TITLE}</td>
                  <td className="p-3">{getLeaveTypeLabel(item?.FKLEAVETYPES)}</td>
                  <td className="p-3">{item?.LEAVES}</td>
                  <td className="p-3">{formatDate(item?.FROMDATE)}</td>
                  <td className="p-3">{formatDate(item?.TODATE)}</td>
                  <td className="p-3">
                    <div className="flex items-center">
                      <div
                        className="mr-2 cursor-pointer bg-blue-100 dark:bg-blue-900 p-1 rounded hover:opacity-80"
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                          setEditingData(item);
                        }}
                      >
                        <PencilSquareIcon className="h-6 w-6 text-blue-500 dark:text-blue-300" />
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      )}
    </div>

  );
};

export default LeavesTable;
